import { Stack } from "@mantine/core";
import { Loading } from "components";
import { ReportParamsType } from "constants/types/common";
import { FC } from "react";
import { useProfitReport } from "utils/hooks/request/useReport";
import ProfitReportTable from "./components/ProfitReportTable/ProfitReportTable";
import ProfitSummaryCards from "./components/ProfitSummaryCards/ProfitSummaryCards";

interface ProfitReportTabProps {
  params: ReportParamsType;
}

const ProfitReportTab: FC<ProfitReportTabProps> = ({ params }) => {
  const { profitReport, isLoading } = useProfitReport(params);

  return (
    <Loading variant="overlay" visible={isLoading}>
      <Stack gap="md">
        {profitReport?.summary && (
          <ProfitSummaryCards summary={profitReport.summary} />
        )}
        <ProfitReportTable data={profitReport?.rows ?? []} />
      </Stack>
    </Loading>
  );
};

export default ProfitReportTab;
